import { initializeApp } from 'firebase/app';

import { getFirebaseConfig } from './firebase-config';
initializeApp(getFirebaseConfig());
